import { render } from "./HistoryDefaults.vue?vue&type=template&id=204963be&scoped=true"
import script from "./HistoryDefaults.vue?vue&type=script&lang=js"
export * from "./HistoryDefaults.vue?vue&type=script&lang=js"

import "./HistoryDefaults.vue?vue&type=style&index=0&id=204963be&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204963be"]])

export default __exports__